import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import PageHero from '../components/PageHero';

export default function PrivacyPolicy() {
  const { lang, t } = useLanguage();

  return (
    <div className="privacy-policy-page">
      {/* Page Hero */}
      <PageHero eyebrow="Perlindungan Data" title={t('footer_privacy')} subtitle="Komitmen PT Solusi Bangun Beton Tbk dalam menjaga kerahasiaan dan keamanan data pribadi pengguna." image="/reference-images/about-company.webp" />

      {/* Breadcrumbs */}
      <div className="breadcrumb-wrapper">
        <div className="container">
          <ul className="breadcrumb-list">
            <li><Link to="/">{t('nav_home')}</Link></li>
            <li><span className="separator">/</span></li>
            <li><span className="current">{t('footer_privacy')}</span></li>
          </ul>
        </div>
      </div>

      {/* Content */}
      <section className="section">
        <div className="container" style={{ maxWidth: '840px' }}>
          <div className="legal-content-box">
            <h2>1. Pendahuluan</h2>
            <p>PT Solusi Bangun Beton Tbk ("SBB", "Kami") menghormati privasi pengunjung dan pengguna situs web kami. Kebijakan Privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, menyimpan, dan melindungi informasi pribadi yang Anda berikan melalui formulir kontak atau penggunaan layanan kami.</p>

            <h2>2. Informasi Yang Kami Kumpulkan</h2>
            <p>Kami dapat mengumpulkan informasi pribadi yang Anda berikan secara sukarela, termasuk namun tidak terbatas pada:</p>
            <ul>
              <li>Nama lengkap</li>
              <li>Alamat email bisnis</li>
              <li>Nomor telepon / WhatsApp</li>
              <li>Detail perusahaan, nama proyek, dan isi pesan inquiry</li>
            </ul>

            <h2>3. Penggunaan Informasi</h2>
            <p>Informasi yang dikumpulkan digunakan semata-mata untuk tujuan:</p>
            <ul>
              <li>Merespons pertanyaan, permintaan penawaran harga, atau konsultasi teknis beton.</li>
              <li>Menghubungi Anda mengenai pembaruan proyek atau status pesanan.</li>
              <li>Meningkatkan kualitas layanan dan pengalaman pengguna di situs web SBB.</li>
            </ul>

            <h2>4. Keamanan & Penyimpanan Data</h2>
            <p>Kami menerapkan langkah-langkah keamanan teknis dan organisasional yang memadai untuk melindungi data Anda dari akses tanpa izin, kehilangan, atau penyalahgunaan. Kami tidak akan menjual atau menyewakan informasi pribadi Anda kepada pihak ketiga.</p>

            <h2>5. Kebijakan Cookie</h2>
            <p>Situs web ini menggunakan cookie esensial dan analitis anonim untuk membantu kami memahami penggunaan situs dan mengoptimalkan performa halaman.</p>

            <h2>6. Kontak Pengelola Privasi</h2>
            <p>Jika Anda memiliki pertanyaan mengenai Kebijakan Privasi ini, silakan hubungi tim hukum dan komunikasi korporat kami via email: <strong>privacy@solusibangunbeton.com</strong>.</p>
            
            <p className="update-date"><em>Terakhir Diperbarui: 10 Agustus 2026</em></p>
          </div>
        </div>
      </section>

      <style>{`
        .legal-content-box {
          font-size: 15px;
          color: var(--color-text);
          line-height: 1.8;
        }

        .legal-content-box h2 {
          font-size: 20px;
          font-weight: 700;
          color: var(--color-ink);
          margin: 32px 0 12px 0;
          border-left: 4px solid var(--color-brand-primary);
          padding-left: 12px;
        }

        .legal-content-box p {
          margin-bottom: 16px;
        }

        .legal-content-box ul {
          padding-left: 24px;
          margin-bottom: 20px;
        }

        .legal-content-box li {
          margin-bottom: 8px;
        }

        .update-date {
          margin-top: 40px;
          color: var(--color-text-muted);
          font-size: 13px;
        }
      `}</style>
    </div>
  );
}
